import rating_bad from './svg/rating_bad.svg';
import rating_good from './svg/rating_good.svg';
import rating_normal from './svg/rating_normal.svg';
import rating_very_bad from './svg/rating_very_bad.svg';
import rating_very_good from './svg/rating_very_good.svg';
import star from './svg/star.svg';
import thumbs_down from './svg/thumbs_down.svg';
import thumbs_up from './svg/thumbs_up.svg';

const svgs = {
  rating_bad,
  rating_good,
  rating_normal,
  rating_very_bad,
  rating_very_good,
  star,
  thumbs_down,
  thumbs_up,
} as const;

export type SvgRatingList = keyof typeof svgs;
export default svgs;
